<script setup lang="ts">
    import { defineAsyncComponent } from 'vue';
    import TopBannerLeft from '../components/oferta/TopBannerLeft.vue'
    import FormarBloque from '../components/oferta/FormarBloqueNeo.vue'; 
    const ProgramaModelo = defineAsyncComponent(() => import('../components/oferta/ProgramaModelo.vue'));
const VerModelo = defineAsyncComponent(() => import('../components/oferta/VerModelo.vue')); 
    const CalendarioOferta = defineAsyncComponent(() => import('../components/oferta/CalendarioOferta.vue')) ;
    const PoliticaIA = defineAsyncComponent(() => import('../components/oferta/PoliticaIA.vue'))
    // const DescargaFolleto = defineAsyncComponent(() => import('../components/oferta/DescargaFolleto.vue')) ; 
    // const LicExcelenciaAcadem = defineAsyncComponent(() => import('../components/oferta/LicExcelenciaAcadem.vue')) ; 
    // const CasosExito = defineAsyncComponent(() => import('../components/oferta/CasosExitoPrime.vue')); 
    
</script>

<template>
    <TopBannerLeft :img="'background-image: url(../../pagesImages/arte.jpg);'" :nivel="'Licenciatura en'" :carrera="'Arte y Teatro'" :frase="'El teatro es tan infinitamente fascinante, porque es muy accidental, tanto como la vida'" :autor="'Arthur Miller'"/>
    <FormarBloque :img="'../../pagesImages/arte-y-teatro.jpg'" :link="'/requisitos-licenciatura'" alt="Alumna de Arte y Teatro Universidad Humanitas" :frase="'Pasión por el Teatro y desarrollo de proyectos artísticos, reconociendo el contexto histórico, teórico, procedimental...'" :testo1="'La licenciatura en Arte y Teatro es un programa profesional que estudia desde los orígenes, historia y manifestación de las expresiones escénicas, abordadas de manera práctica, para formar expertos capaces de transformar el mundo cultural con su visión artística.'" :testo2="'Formamos profesionales con una sólida base de conocimientos, destrezas, habilidades y aptitudes.'" :testo3="'Está dirigido para aquellos apasionados por el Arte y el Teatro e interés por conocer, analizar y producir expresiones artísticas, con el propósito de transmitir opiniones y sentimientos de manera creativa e innovadora.'" />
    <div class="flex items-center justify-center mb-12">
    </div>
    <ProgramaModelo :escolarizado="true"/>
    <VerModelo esco="/pagesImages/Programas/Licenciatura/Escolarizado/lic-arte-y-teatro-escolarizado.webp"
    :escoT="true"
    :ejecT="false"
    :virtT="false" />
    <CalendarioOferta nombre="Licenciatura en Arte y Teatro" :titulo="'Calendario de la licenciatura Escolarizada'" :subtitulo="'Conoce el programa de licenciatura que consolidará.'"
  :inicios="[true, true, false, false, true, true, false, false]"></CalendarioOferta>
    <EgresadosHuma :types="'Licenciatura Arte'" class="mb-16" />
    
    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-0 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between w-full">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block leading-none text-left text-[28px]" style="">Campus Humanitas que </span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-hgold text-left font-serif mb-3 text-[42px]">cuentan con esta licenciatura</span>
                        </h2>
                        <!-- <p class="mb-4">Esta licenciatura está disponible en los siguientes Campus:</p> -->
                        <ul class="list-disc pl-8 mb-4">
                            <li>Presa Madín</li>
                            <li>Querétaro</li>
                        </ul>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/fachada-campus-madin.webp" alt="Imagen de fachada de Campus Madín" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
    </section>

    <section class="flex  justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-0 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between">
				<div class="lg:flex justify-center">
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/licenciaturas-estructura.webp" alt="Estructura académica en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
					</div>
                    <div class="lg:w-[50%] text-justify mt-8 lg:mt-0 lg:ml-12">
                        <h2>
                            <span class="block font-serif text-[42px] text-hgold text-left" style="">Estructura académica</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-xl text-left mb-3">(Bloques temáticos):</span>
                        </h2>
                        <ul class="list-disc pl-3 hyphens-auto">
                            <li><b>Historia y teoría del Teatro:</b> Teatro originario y moderno, corrientes innovadoras, cultura teatral, creatividad, el artista frente al texto y en el escenario.</li>
                            <li><b>Historia y pensamiento cultural:</b> Grecia, Roma, la modernidad, bases conceptuales del arte, Filosofía del arte, plástica teatral, teoría y antropología del Arte, movimientos sociales y representaciones artísticas, así como pensamiento artístico.</li>
                            <li><b>Función, interpretación y tendencias del arte:</b> Arte, hermenéutica y Comunicación, artes interdisciplinarias, nuevas tendencias artísticas y plásticas, arte y multimedia, interpretación, herramientas analíticas, análisis comparativo del texto dramático y elementos del drama.</li>
                            <li><b>Literatura:</b> Occidental contemporánea, narrativa latinoamericana y modelos literarios europeos.</li>
                            <li><b>Puesta en escena y medios audiovisuales:</b> Videoarte y arte sonoro, instalación.</li>
                            <li><b>Gestión y producción artística:</b> Dirección de escena, producción artística, Mercadotecnia del arte.</li>
                            <li><b>Talleres y seminarios profesionales:</b> Taller profesional II, III, IV, V, seminario de desarrollo profesional I, II, III, IV y V.</li>
                            <li><b>Idiomas:</b> Inglés I, II, III, IV, V, VI, VII, VIII. Solo en modelo escolarizado.</li>
                        </ul>
                    </div>
                </div>
			</div>
		</div>
	</section>
    
    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-0 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between w-full">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block leading-none text-left text-[28px]" style="">Cinco razones para elegir</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-hgold text-left font-serif mb-3 text-[42px]">Universidad Humanitas:</span>
                        </h2>
                        <ul class="list-disc pl-8 mb-4">
                            <li>Modelo educativo especializado.</li>
                            <li>Excelencia académica.</li>
                            <li>Instalaciones de primer nivel.</li>
                            <li>Costos accesibles.</li>
                            <li>Acreditaciones reconocidas (SEP, ESR y GPTW).</li>
                        </ul>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/beneficios-estudiar-universidad-humanitas.webp" alt="Beneficios de estudiar en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section>
    <PoliticaIA />
</template>

<style scoped>
</style>